'use strict';

const isDesktopView = () => {
    const desktopMinWidth = 1025;
    const vpWidth = $(window).width();

    return vpWidth >= desktopMinWidth;
};

module.exports = isDesktopView;
